import styled from '@emotion/styled';
import ImageListItem from '@mui/material/ImageListItem';

export { default } from '@mui/material/ImageListItem';

export const ImageBrowserListItem = styled(ImageListItem)`
  cursor: pointer;
  min-height: 344px;
`;
